<template>
  <div class="modal fade">
  <v-dialog :value="value" content-class="edit-post-modal" @input="$emit('input')" max-width="500px">
    <v-layout>
      <v-flex xs12>
        <v-card v-if="postData">
          <v-toolbar dense class="elevation-2">
            <v-toolbar-title>Edit Live Date</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon><v-icon @click="closeModal">close</v-icon></v-btn>
          </v-toolbar>
          <v-form id="postLiveDateEditForm">
            <v-card-text>
              <v-row>
                <v-col md="12" xs="12">
                  <v-dialog
                    ref="dateDialog"
                    v-model="datePickerDialog"
                    :return-value.sync="postData.postDate"
                    persistent
                    width="290px"
                    v-if="showSetDateOption"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="postData.postDate"
                        label="Pick a Date that this post should publish"
                        append-icon="event"
                        name="postDate"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="postData.postDate" scrollable :min="todayDatePick">
                      <v-spacer></v-spacer>
                      <v-btn text color="secondary" @click="datePickerDialog = false">Cancel</v-btn>
                      <v-btn text color="secondary" @click="$refs.dateDialog.save(postData.postDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-dialog
                    ref="endDateDialog"
                    v-model="endDatePickerDialog"
                    :return-value.sync="postData.postDateEnd"
                    persistent
                    width="290px"
                    v-if="showSetDateOption"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="postData.postDateEnd"
                        label="Pick a Date that this post should publish latest by"
                        append-icon="event"
                        name="postDateEnd"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="postData.postDateEnd" scrollable :min="postData.postDate">
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="endDatePickerDialog = false">Cancel</v-btn>
                      <v-btn color="secondary" @click="$refs.endDateDialog.save(postData.postDateEnd)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="mb-2">
              <v-spacer></v-spacer>
              <v-btn @click.native="closeModal" dark color="red">Cancel</v-btn>
              <v-btn @click="submit" dark color="green">Save Changes</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
      <v-dialog v-model="loading" hide-overlay persistent width="250">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
import moment from 'moment';
import campaignHelper from '../Campaign/campaignHelper';
import utils from '@/utils';
export default {
  name: 'EditLiveDateModal',
  components: {
  },
  props: {
    value: Boolean,
    post: Object
  },
  data() {
    return {
      loading: false,
      postData: null,
      datePickerDialog: false,
      endDatePickerDialog: false,
      showSetDateOption: true,
      todayDatePick: '',
      influencerRole: config.userRoles.INFLUENCER,
      campaignHelper
    };
  },
  computed: {
    ...mapState({
      updated: state => state.post.updated
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    }
  },
  watch: {
    post(newVal) {
      this.postData = newVal || null;
    }
  },
  mounted() {
    this.todayDatePick = moment().format('YYYY-MM-DD');
  },
  methods: {
    submit() {
      if (!this.postData.postDate || !this.postData.postDateEnd) {
        this.$swal({
          text: 'Please enter post dates.',
          type: 'error'
        });
        return
      }
      let editData = this.buildFormData();
      this.$swal({
        title: 'Do you want to save changes?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch('post/saveLiveDate', editData)
          this.$swal({
            title: 'Submitted successfully',
            type: 'success'
          }).then(() => {
            this.$emit('input');
            this.$emit('postUpdated');
          });
        }
      });
    },
    buildFormData() {
      let form = document.getElementById('postLiveDateEditForm');
      let formData = new FormData(form);
      formData.append('postID', this.postData._id)
      return formData;
    },
    closeModal() {
      this.$emit('input')
      this.pauseVideo()
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY, HH:mm');
    },
    async loadCampaign(post) {
      this.postData = utils.func.refreshJSON(this.postData)
    }
  }
};
</script>
<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// EditLiveDateModal.vue?7ecc85e8